document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tabs button')

    buttons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            if (!this.getAttribute('data-tab')) {
                return
            }

            e.preventDefault()

            const tab = this.getAttribute('data-tab')
            const parent = this.closest('.tabs-wrapper')

            buttons.forEach(function (btn) {
                btn.classList.remove('active')
            })

            this.classList.add('active')

            const contents = parent.querySelectorAll('.tab-content')
            contents.forEach(function (content) {
                content.classList.remove('active')
            })

            const activeContent = parent.querySelector(`.tab-content[data-tab='${tab}']`)
            if (activeContent) {
                activeContent.classList.add('active')
            }
        })
    })
})
